// extracted by mini-css-extract-plugin
export default {"root":"mobile-preview-shell_root__uEzob","host":"mobile-preview-shell_host__WBYgA","stage":"mobile-preview-shell_stage__Spy8n","viewport":"mobile-preview-shell_viewport__SuMG8"};